import Vue from 'vue'

import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import "./element-variables.scss"

Vue.use(ElementUI)
